// extracted by mini-css-extract-plugin
module.exports = {"article-intro":"ArticleIntro_article-intro__Ex_NL"};